import script from "./reviewDetail.vue?vue&type=script&setup=true&name=ExamineDetail&lang=js"
export * from "./reviewDetail.vue?vue&type=script&setup=true&name=ExamineDetail&lang=js"

import "./reviewDetail.vue?vue&type=style&index=0&id=50258fea&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50258fea"]])

export default __exports__